import React from "react";
import "../../css/Privacy.css";
import Header from "./../Header/index";
import Footer from "./../Footer/Footer";

class Privacy
 extends React.Component {
   
    render() { 
        return (
          <>
            <div className="privacyContainer">
              <Header />

              <div className="container-row">
                <div className="col-sm-12 topMargin">
                  <div className="TermsCenter">
                    <h1>Terms of Service</h1>

                    <div className="topParagraph">
                      Read our terms below to learn more about your rights and
                      responsibilities as a Fitfinity user.
                    </div>
                  </div>
                  <img
                    className="privacyImage"
                    src={require("../../assests/hand.png")}
                  />
                </div>
              </div>
              <hr />
  <div className="container-fluid">
              <div className="row">
                <div className="col-sm-2"></div>
                <div className="col-sm-8">
                  <div className="formarginbottom">
                    This Privacy Policy is to help our users better understand
                    what information we collect about them and what may happen
                    to that information.
                  </div>

                  <div className="formarginbottom">
                    <strong>Privacy Policy IND</strong>
                  </div>

                  <div className="formarginbottom">
                    This Privacy Policy agreement is effective as of
                    10-November-2019.
                  </div>
                  <div className="formarginbottom">
                    Fitfinity Online Private Limited ("Fitfinity") values your
                    privacy. In this Privacy Policy we describe the information
                    that we collect about you when you visit our website,
                    www.Fitfinity.com (the "Website") and use the services
                    available on the Website ("Services"), and how we use and
                    disclose that information.
                  </div>

                  <div className="formarginbottom">
                    If you have any questions or comments about the Privacy
                    Policy, please contact us at{" "}
                    <a href="/support@Fitfinity">support@Fitfinity.com.</a> In terms
                    of the Information Technology (Intermediaries Guidelines)
                    Rules, 2011 and the Information Technology (Reasonable
                    Security Practices and Procedures and Sensitive Personal
                    Data or Information) Rules, 2011, any grievance or complaint
                    may be intimated to B. Jayan, who may be reached at,(#48,
                    29th Main , 5th Block Survey No. 13,14 & 15, Nandini Layout,
                    Yaswantpur, Bangalore, Karnataka-560096 IN (“Bangalore
                    Corporate Office”).) India. The complaint shall be redressed
                    within a period of 1 (one) month.
                  </div>
                  <div className="formarginbottom">
                    <strong>COLLECTION OF PERSONAL INFORMATION</strong>
                  </div>

                  <div className="formarginbottom">
                    “Personal information” is defined to include information
                    that whether on its own or in combination with other
                    information may be used to readily identify or contact you
                    such as: name, address, email address, phone number etc.
                  </div>
                  <div className="formarginbottom">
                    Consumers: During the Account registration process and
                    during your usage of Fitfinity website or application, we
                    will collect information such as your name, postal code,
                    telephone email address and other personal information. You
                    also may provide us with your, mailing address, and
                    demographic information (e.g., gender, age, political
                    preference, education, race or ethnic origin, and other
                    information relevant to user surveys and/or offers). We may
                    also collect personal information that you post in your
                    Offer, Profile, Wants, or Feedback, and any comments or
                    discussions you post in any blog, chat room, or other
                    correspondence site on the Website or mobile application, or
                    any comments you provide during dispute resolution with
                    other users of the Website or mobile application.
                  </div>
                  <div className="formarginbottom">
                    Service Professional Background Verification: The Service
                    Professional acknowledges that as part of the on-boarding
                    process, the Company or an entity /agency appointed or
                    nominated by the Company (“Verifier”), may undertake
                    background verification checks of the Service Professional
                    in order to authenticate inter alia the genuineness and
                    competency of the Service Professional. In light of the
                    above, the Service Professional expressly consents to and
                    acknowledges the following:
                  </div>
                  <div className="formarginbottom">
                    <ul>
                      <li>
                        i) The Service Professional does not and will not have
                        any objection to Fitfinity sharing the Service
                        Professional’s personal information and documents,
                        including but not limited to name, gender, date of
                        birth, addresses, mobile number, email, education
                        record, employment record, Aadhaar number, other
                        government issued IDs such as Voter ID, PAN card,
                        driving license etc. (collectively “Proprietary
                        Information”) with the Verifier for the purpose of
                        background checks and verification.
                      </li>
                      <li>
                        ii) The Service Professional authorizes the Verifier to
                        securely store the Service Professional’s Proprietary
                        Information on their platform and understands that the
                        Verifier shall endeavour to ensure confidentiality of
                        the same.
                      </li>
                      <li>
                        iii) The Service Professional acknowledges that the
                        digital record of the Proprietary Information on the
                        Verifier’s platform shall be accessible to Fitfinity and
                        their authorized users/partners/affiliates/contractors
                        shall be entitled to access and update such digital
                        record on the Verifier’s platform, including data,
                        documents, certificates, verification reports,
                        references, testimonials, etc. and shall be entitled to
                        use the related services provided via the Verifier’s
                        platform.
                      </li>
                      <li>
                        iv) The Service Professional acknowledges that if the
                        Service Professional is desirous of editing and/or
                        deleting its digital record from the Verifier’s
                        platform, it shall be entitled to do so by sending an
                        email to such email address of the Verifier which shall
                        be immediately provided by the Company to the Service
                        Professional, and in such a manner as the Verifier
                        requires the same.
                      </li>
                      <li>
                        v) Fitfinity reserves its right to take appropriate actions
                        (in its sole discretion) pursuant to the outcome of the
                        background check and verification.
                      </li>
                    </ul>
                  </div>

                  <div className="formarginbottom">
                    Fitfinity reserves the right to record the conversations
                    between service professionals and consumers facilitated by
                    Fitfinity through the messaging/chat mechanism on the platform
                    or the calls made through the virtual numbers provided to
                    safeguard the privacy of consumers and service
                    professionals. All the chat/messaging logs or call
                    recordings can be used to but not limited to monitor and
                    prohibit abuse, safeguard the rights of consumers and
                    service professionals, resolve disputes.
                  </div>
                  <div className="formarginbottom">
                    If we deem it necessary, in our sole and absolute
                    discretion, we may also ask for and collect supplemental
                    information from third parties, such as information about
                    your credit from a credit bureau (to the extent permitted by
                    law), or information to verify any identification details
                    you provide during registration.
                  </div>
                  <div className="formarginbottom">
                    <strong>
                      COLLECTION OF PERSONAL INFORMATION FROM SOCIAL NETWORKING
                      SITES
                    </strong>
                  </div>
                  <div className="formarginbottom">
                    You may log into our Website through your social media
                    account. If you do so, you must enter the email address and
                    password that you use for your social media account. We will
                    ask that you grant us permission to access and collect your
                    social media account basic information (this includes your
                    name, profile picture, gender, networks, user IDs, list of
                    friends, date of birth, email address, If you allow us to
                    have access to this information, then we will have access to
                    this information. We store the information that we receive
                    from your social media account with other information that
                    we collect from you or receive about you.
                  </div>
                  <div className="formarginbottom">
                    <strong>
                      COLLECTION OF AUTOMATIC INFORMATION, USE OF COOKIES AND
                      OTHER TRACKING DEVICES
                    </strong>
                  </div>
                  <div className="formarginbottom">
                    We and our third party service providers, which include ad
                    networks, use cookies, web beacons, and other tracking
                    technologies to collect information about your use of our
                    Website and Services, such as your browser type, your ISP or
                    operating system, your domain name, your access time, the
                    URL of the previous website you visited, your page views,
                    your IP address, and the type of device that you use. We
                    also track how frequently you visit our Website and use our
                    Services. We use this information (including the information
                    collected by our third party service providers) for Website
                    analytics (including to determine which portions of our
                    Website are used most frequently, what our users like/do not
                    like), to assist us in determining relevant advertising
                    (both on and off our Website), to evaluate the success of
                    our advertising campaigns, and as otherwise described in
                    this policy. Currently, we do not honour browser requests
                    not to be tracked.Disabling Cookies. You can choose to
                    accept or decline cookies. Most web browsers automatically
                    accept cookies, but you can usually modify your browser
                    setting to decline cookies if you prefer. If you disable
                    cookies you may be prevented from taking full advantage of
                    the Website because it may not function properly if the
                    ability to accept cookies is disabled. Clear GIFs, pixel
                    tags and other technologies in connection with our Website
                    to, among other things, track the activities of Website
                    visitors, help us manage content, and compile statistics
                    about Website usage. We and our third party service
                    providers also use clear GIFs in HTML emails to our
                    customers, to help us track email response rates, identify
                    when our emails are viewed, and track whether our emails are
                    forwarded.
                  </div>
                  <div className="formarginbottom">
                    <strong>HOW PERSONAL INFORMATION IS USED IN Fitfinity</strong>
                  </div>

                  <div className="formarginbottom">
                    <ul>
                      <li>
                        We collect your personal information and aggregate
                        information about the use of our Website and Services to
                        better understand your needs and to provide you with a
                        better Website experience. Specifically, we may use your
                        personal information for any of the following reasons:
                      </li>
                      <li>
                        To provide our Services to you, including registering
                        you for our Services, verifying your identity and
                        authority to use our Services, and to otherwise enable
                        you to use our Website and our Services;
                      </li>
                      <li>
                        For customer support and to respond to your inquiries
                      </li>
                      <li> For internal record-keeping purposes;</li>
                      <li>
                        To process billing and payment, including sharing with
                        third party payment gateways in connection with Website
                        and/or Fitfinity's products and Services;
                      </li>
                      <li>
                        To improve and maintain our Website and our Services
                        (for example, we track information entered through the
                        "Search" function; this helps us determine which areas
                        of our Website users like best and areas that we may
                        want to enhance; we also will use for trouble-shooting
                        purposes, where applicable);
                      </li>
                      <li>
                        To periodically send promotional emails to the email
                        address you provide regarding new products from Fitfinity,
                        special offers from Fitfinity or other information about
                        Fitfinity that we think you may find interesting;
                      </li>
                      <li>
                        To contact you via email, telephone, facsimile or mail,
                        or, where requested, by text message, to deliver certain
                        services or information you have requested;
                      </li>
                      <li>
                        For Fitfinity's market research purposes, including, but
                        not limited to, the customization of the Website
                        according to your interests;
                      </li>
                      <li>
                        We may use your demographic information (i.e., age,
                        postal code, residential and commercial addresses, and
                        other various data) to more effectively facilitate the
                        promotion of goods and services to appropriate target
                        audiences and for other research and analytical
                        purposes;
                      </li>
                      <li>
                        To resolve disputes, to protect ourselves and other
                        users of our Website and Services, and to enforce our
                        Terms of Use;
                      </li>
                      <li>
                        We also may compare personal information collected
                        through the Website and Services to verify its accuracy
                        with personal information collected from third parties;
                        and
                      </li>
                      <li>
                        We may combine aggregate data with the personal
                        information we collect about you.
                      </li>
                      <li>
                        From time to time, Fitfinity may use personal information
                        for new and unanticipated uses not previously disclosed
                        in our Privacy Policy. If our information practices
                        change regarding information previously collected,
                        Fitfinity shall make reasonable efforts to provide notice
                        and obtain consent of any such uses as may be required
                        by law.
                      </li>
                    </ul>
                    <div className="formarginbottom">
                      At our sole discretion, Fitfinity may offer any of the
                      following free services on the Website, which you may
                      select to use or receive at your option. Certain of the
                      following services may require you to provide additional
                      personal information as detailed below:
                    </div>
                    <div className="formarginbottom">
                      <strong>1.ELECTRONIC NEWSLETTERS</strong>
                    </div>
                    <div className="formarginbottom">
                      We may offer a free electronic newsletter to users. We
                      will gather the email addresses of users who sign up for
                      Fitfinity for the newsletter mailing list. Users may remove
                      themselves from this mailing list by opting out of
                      receiving newsletters during the registration process, by
                      following the link provided in each newsletter that points
                      users to a subscription management page where the user can
                      unsubscribe from receiving newsletters or by changing
                      their preferences in their Profile Settings page.
                    </div>
                    <div className="formarginbottom">
                      <strong>2.SEND TO A FRIEND</strong>
                    </div>
                    <div className="formarginbottom">
                      Our Website users can voluntarily choose to electronically
                      forward a link, page, or document to someone else by
                      clicking "send to a friend." To do so, the user must
                      provide his or her email address, as well as the email
                      address of the recipient. The user's email address is used
                      only in the case of transmission errors and, of course, to
                      let the recipient know who sent the email. The information
                      is not used for any other purpose.
                    </div>
                    <div className="formarginbottom">
                      <strong>3.POLLING</strong>
                    </div>

                    <div className="formarginbottom">
                      We may offer interactive polls to users so they can easily
                      share their opinions with other users and see what our
                      audience thinks about important issues, Services, and/or
                      the Website. Opinions or other responses to polls are
                      aggregated and are not identifiable to any particular
                      user. We may use a system to "tag" users after they have
                      voted, so they can vote only once on a particular
                      question. This tag is not correlated with information
                      about individual users.
                    </div>
                    <div className="formarginbottom">
                      <strong>4.SURVEYS</strong>
                    </div>
                    <div className="formarginbottom">
                      We may conduct user surveys from time to time to better
                      target our content to our Website users. We will not share
                      individual responses from these surveys with any third
                      party. We will share aggregate data with third party
                      service providers, partners, and other third parties. We
                      also will post aggregate data containing survey responses
                      on our Website; that data may be viewed and downloaded by
                      other users of our Website.
                    </div>
                    <div>
                      <strong>Security</strong>
                    </div>
                    <div className="formarginbottom">
                      We employ procedural and technological security measures,
                      which are reasonably designed to help protect your
                      personal information from unauthorized access or
                      disclosure. Fitfinity may use encryption, passwords, and
                      physical security measures to help protect your personal
                      information against unauthorized access and disclosure. No
                      security measures, however, are 100% complete. Therefore,
                      we do not promise and cannot guarantee, and thus you
                      should not expect, that your personal information or
                      private communications will not be collected and used by
                      others. You should take steps to protect against
                      unauthorized access to your password, phone, and computer
                      by, among other things, signing off after using a shared
                      computer, choosing a robust password that nobody else
                      knows or can easily guess, and keeping your log-in and
                      password private. Fitfinity is not responsible for the
                      unauthorized use of your information or for any lost,
                      stolen, compromised passwords, or for any activity on your
                      Account via unauthorized password activity.
                    </div>

                    <div className="formarginbottom">
                      <strong>Disclosure</strong>
                    </div>

                    <div className="formarginbottom">
                      We may share the information that we collect about you,
                      including your personal information, as follows:
                    </div>

                    <div className="formarginbottom">
                      <ol>
                        <li>
                          We may disclose your information including Personal
                          Information if: (i) Fitfinity reasonably believes that
                          disclosure is necessary in order to comply with a
                          legal process (such as a court order, search warrant,
                          etc.) or other legal requirement of any governmental
                          authority, (ii) disclosure would potentially mitigate
                          our liability in an actual or potential lawsuit, (iii)
                          reasonably necessary to enforce this Privacy Policy,
                          our Terms of Use etc. (iv) disclosure is intended to
                          help investigate or prevent unauthorized transactions
                          or other illegal activities, or (v) necessary or
                          appropriate to protect our rights or property, or the
                          rights or property of any person or entity.
                        </li>
                        <li>
                          We may contract with various third parties for the
                          provision and maintenance of the Website, Services and
                          our business operations, and Fitfinity may need to share
                          your personal information and data generated by
                          cookies and aggregate information (collectively,
                          "information") with these vendors and service
                          agencies. For example, we may provide your information
                          to a credit card processing company to process your
                          payment. The vendors and service agencies will not
                          receive any right to use your personal information
                          beyond what is necessary to perform its obligations to
                          provide the Services to you. If you complete a survey,
                          we also may share your information with the survey
                          provider; if we offer a survey in conjunction with
                          another entity, we also will disclose the results to
                          that entity.
                        </li>
                        <li>
                          Your request for services may be shared with third
                          party websites with whom we have a contractual
                          relationship in order to provide your request with
                          maximum exposure. The post on the third party website
                          will include the details of your request, including
                          your location, and other contact details. Interested
                          bidders, however, will be able to click on your
                          request on such third party site, and will be directed
                          to our Website where they will have access to your
                          contact details (Partial or complete), as would any
                          other service provider on our Website interested in
                          bidding on your request.
                        </li>
                        <li>
                          If you are a Service Professional, the information
                          that you post (other than your payment information) is
                          available to other users of our Website and our
                          Services. Comments that users post to our Website also
                          will be available to other visitors to our Website
                          (see our discussion of User Generated Content below).
                          In addition, we will post the results (in aggregate
                          form) of surveys to our Website. If you are a
                          consumer, name, and location, as well as the details
                          of your request, are available to all visitors to our
                          Website. Bidding professionals also will be permitted
                          to see the consumer's full name, telephone number,
                          email address and the –location
                        </li>
                        <li>
                          We will disclose your information, including, without
                          limitation, your name, city, state, telephone number,
                          email address, user ID history, quoting and listing
                          history, and fraud complaints, to law enforcement or
                          other government officials if we are required to do so
                          by law, regulation or other government authority or
                          otherwise in cooperation with an investigation of a
                          governmental authority.
                        </li>
                        <li>
                          In the event that Fitfinity undergoes a change in
                          control, including, without limitation, a merger or
                          sale of all or substantially all of Fitfinity's assets to
                          which this Website relates or other corporate
                          reorganization in which Fitfinity participates, and is
                          thus merged with or acquired by a third party entity
                          (a "Successor"), Fitfinity hereby reserves the right to
                          transfer the information we have collected from the
                          users of the Website and/or Services to such
                          Successor.In addition, in the event of Fitfinity's
                          bankruptcy, reorganization, receivership, or
                          assignment for the benefit of creditors, or the
                          application or laws or equitable principles affecting
                          creditors' rights generally, Fitfinity may not be able to
                          control how your information is transferred, used, or
                          treated and reserves the right to transfer the
                          information we have collected from the users of the
                          Website and/or Services to non-affiliated third
                          parties in such event.
                        </li>
                        <li>
                          We may share your personal information with other
                          Registered Users to whom you explicitly ask us to send
                          your information or if you explicitly consent to such
                          disclosure upon receipt of a specific Service. For
                          instance, when you contract for a specific Service
                          with another Registered User, Fitfinity will send that
                          Registered User a notice that includes the personal
                          information that you have chosen to allow Fitfinity to
                          reveal to users with whom you contract.
                        </li>
                      </ol>
                    </div>

                    <div className="formarginbottom">
                      <strong>
                        Updating, Deleting and Correcting Your Personal
                        Information
                      </strong>
                    </div>

                    <div className="formarginbottom">
                      You may choose to restrict the collection or use of your
                      personal information in the following ways:
                    </div>
                    <div className="formarginbottom">
                      You can review, correct and delete your personal
                      information by logging into the Website and navigating to
                      your preferences page in "Edit Profile." You must promptly
                      update your personal information if it changes or is
                      inaccurate. Typically, we will not manually alter your
                      personal information because it is very difficult to
                      verify your identity remotely. Nonetheless, upon your
                      request we will close your Account and remove your
                      personal information from view as soon as reasonably
                      possible based on your Account activity and in accordance
                      with applicable law. We do retain information from closed
                      Accounts in order to comply with the law, prevent fraud,
                      collect any fees owed, resolve disputes, troubleshoot
                      problems, assist with any investigations of any Registered
                      User, enforce our Terms of Use, and take any other actions
                      otherwise permitted by law that we deem necessary in our
                      sole and absolute discretion. You should understand,
                      however, that once you publicly post a Request, Offer,
                      Want, Feedback, or any other information onto the Website,
                      you may not be able to change or remove it. Once we have
                      deleted or removed your Account, you agree that Fitfinity
                      shall not be responsible for any personal information that
                      was not included within your deleted and/or removed
                      Account that remains on the Website.
                    </div>
                    <div className="formarginbottom">
                      IF YOUR PASSWORD HAS BEEN COMPROMISED FOR ANY REASON, YOU
                      MUST IMMEDIATELY NOTIFY Fitfinity TO CHANGE YOUR PASSWORD.
                    </div>
                    <div className="formarginbottom">
                      <strong>Privacy Policy Updates</strong>
                    </div>
                    <div className="formarginbottom">
                      THIS POLICY IS CURRENT AS OF THE EFFECTIVE DATE SET FORTH
                      ABOVE. Fitfinity MAY, IN ITS SOLE AND ABSOLUTE DISCRETION,
                      CHANGE THIS POLICY FROM TIME TO TIME BY UPDATING THIS
                      DOCUMENT. Fitfinity WILL POST ITS UPDATED POLICY ON THE
                      WEBSITE ON THIS PAGE. Fitfinity ENCOURAGES YOU TO REVIEW THIS
                      POLICY REGULARLY FOR ANY CHANGES. YOUR CONTINUED USE OF
                      THIS WEBSITE AND/OR CONTINUED PROVISION OF PERSONAL
                      INFORMATION TO US WILL BE SUBJECT TO THE TERMS OF THE
                      THEN-CURRENT POLICY.
                    </div>

                    <div className="formarginbottom">
                      <strong>
                        Fitfinity India Technology Private Limited. All Rights
                        Reserved
                      </strong>
                    </div>
                  </div>
                  <div className="col-sm-2"></div>
                </div>
              </div>
            </div>
</div>
            <Footer />
          </>
        );
    }
}
 
export default Privacy
;